<template>
    <section>
      <!--<header class="mui-bar mui-bar-nav">-->
        <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
        <!--<h1 class="mui-title">取样判定-取样</h1>-->
    <!--</header>-->
    <div class="mui-content">
      <div class="title-name">
        <span class="">取样判定{{paraInfo.ddqf=='3'?'(初反)':''}}-取样</span>
      </div>
      <div style="padding-top: 15px;">
        <!--第一行-->
        <div class="form-group">
          <div class="input-label">
            <label>外注订单：</label>
          </div>
          <div class="form-input form-group-new" >
            {{paraInfo.ddh}}
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label >物料：</label>
          </div>
          <div class="form-input form-group-new" >
            {{paraInfo.scxtwph+" "+paraInfo.scxtwpmc}}
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">坯布品番：</label>
          <div class="form-input" style="display: flex;">
            <select v-model="info.clothcode" style="flex: 6;" :disabled="!insertflg">
              <option :value="item.pbph" v-for="item in clothcodeLst">{{item.pbph}}</option>
            </select>
            <span class="input-label" style="flex:1;">
            </span>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">取样机台：</label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex: 6;" v-model="info.machineno" maxlength="10" @blur.prevent="toUpperCase('machineno')"/>
            <span class="input-label" style="flex:1;">
            </span>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">轴号：</label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex: 6;" v-model="info.rollernumber" maxlength="20" @blur.prevent="toUpperCase('rollernumber')"/>
            <span class="input-label" style="flex:1;">
            </span>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">取样时间：</label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex: 6;" :data-options='dataoptions' v-model="info.sampletime" @tap="showpicker"/>
            <span class="input-label" style="flex:1;">
            </span>
          </div>
        </div>
          <div class="form-group">
            <label class="input-label">取样数量：</label>
            <div class="form-input" style="display: flex;">
              <input style="flex: 5;" v-model.number="info.amount" type="number" oninput="if(value.length>8)value=value.slice(0,8)" />
              <span class="input-label" style="flex:2;text-align: left;padding-left: 15px;">
                米
              </span>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">位置：</label>
            <div class="form-input" style="padding-top: 4px;">
              <div class="mui-input-row mui-radio mui-left">
              <input  type="radio" style="vertical-align: middle;"  name="location" v-model="info.location"value="1"/>
              <label  style="vertical-align: middle;">初反</label>
            </div>
            <div class="mui-input-row mui-radio mui-left" v-show="info.ddqf == '1'">
              <input  type="radio" style="vertical-align: middle;"  name="location" v-model="info.location"value="2"/>
              <label>中途</label>
            </div>
            <div class="mui-input-row mui-radio mui-left" v-show="info.ddqf == '1'">
              <input  type="radio" style="vertical-align: middle;"  name="location" v-model="info.location"value="3"/>
              <label>了机</label>
            </div>
            <div class="mui-input-row mui-radio mui-left" v-show="info.ddqf == '1'">
              <input  type="radio" style="vertical-align: middle;"  name="location" v-model="info.location"value="5"/>
              <label>品质确认</label>
            </div>
            <div class="mui-input-row mui-radio mui-left" v-show="info.ddqf == '1'">
              <input  type="radio" style="vertical-align: middle;"  name="location" v-model="info.location"value="6"/>
              <label>反末染</label>
            </div>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-top: 20px;">
            <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;width: 80px;" @tap="save">保存</button>
          </div>
        </div>
    </div>
    </section>
</template>

<script>
    import "../../static/js/mui.picker.min.js";
    export default {
        name: "samplingUpdate",
        data(){
          return{
            //dataoptions:'{"type":"date"}', // 年视图(年月日)
            dataoptions:'{"type":"datetime"}',// 完整日期视图(年月日时分)
            paraInfo:{ddh:"",wph:"",scxtwph:"",scxtwpmc:"",ddqf:"" },
            insertflg:true,
            info:{sampleno:"",ddh:"",wph:"",ddqf:"",sampletime:"",amount:0.0,rollernumber:"",location:"1",machineno:"",tsdrollnolist:[{tsdrollno:"",machineno:"",clothcode:""}]},
            clothcodeLst: []
          }
        },
        methods:{
          toUpperCase(name){
            var v = this;
            if(name == 'machineno'){
              v.info.machineno = (v.info.machineno).toUpperCase();
            }else if(name == 'rollernumber'){
              v.info.rollernumber = (v.info.rollernumber).toUpperCase();
            }
          },
          showpicker(){
            var v=this;
            var dDate = new Date();
            var optionsJson = v.dataoptions;
            var options = JSON.parse(optionsJson);
            var picker = new mui.DtPicker(options);
            picker.show(function (rs) {
              console.log(rs)
              var timestr = rs.text;
              v.info.sampletime=timestr.replace(/-/g,"/");
              picker.dispose();
            });
          },
          getFormatDate(date) {
            var seperator1 = "/";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
          },
          handleInput(e){
          // 通过正则过滤小数点后两位
          // 或者 <input v-model.number="age" type="number"> 限制只能输入数字
          // TODO:
             
              //e.target.value =(e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null;
          },
          save(){
            var v=this;
            if(v.info.machineno==""){
               mui.toast("请输入取样机台！");
               return;
            }
            v.info.machineno = (v.info.machineno).toUpperCase();
            if(v.info.rollernumber==""){
               mui.toast("请输入轴号！");
               return;
            }
            v.info.rollernumber = (v.info.rollernumber).toUpperCase();
            if(v.info.amount==0|| v.info.amount==""){
               mui.toast("请输入取样数量！");
               return;
            }
            if(!is4SZ(v.info.amount)){
               mui.toast("请输入合法取样数量！");
               return;
            }
            if(parseInt(v.info.amount)>999){
                mui.toast("请输入合法取样数量");
                return false;
            }
            var url="";
            if(v.insertflg){
              v.info.tsdrollnolist[0].machineno=v.info.machineno;
              url="/Sample/insertSample";
            }
            else{
              url="/Sample/updSample";
            }
            v.nyy.doPost(url,v.info, 
              function(result){
                if(result.status){
                   v.$router.replace({"name":"samplingHis",params: jsonPara(v.paraInfo)});
                } else {
                          mui.toast(result.message);
                          return;
                      }
              }
            );
          },
          getPbphList(callback){
            var v = this;
            v.nyy.doPost("/Quality/getJDetail", {ddh: v.paraInfo.ddh,wph: v.paraInfo.wph},function(result) {
                if (result.status) {
                  // 坯布品番
                  v.clothcodeLst = result.data.pbphInfoList;
                  //v.clothcodeLst = [{"pbph":"WZ3450","gcfc":50.0,"bzzl":6.23,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M"},{"pbph":"WZ3450-1","gcfc":50.0,"bzzl":0.01,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M"}];
                  if(callback)callback();
                }
              }
            );
          }
        },
        activated() {
          var v=this;
            var para = getJsonPara(v.$route);
            v.paraInfo.ddh=para.ddh;
            v.paraInfo.wph=para.wph;
            v.paraInfo.scxtwph=para.scxtwph;
            v.paraInfo.scxtwpmc=para.scxtwpmc;
            v.paraInfo.ddqf=para.ddqf;
            var sampleno=para.sampleno;
            if(sampleno!="" && sampleno!=undefined){
              v.insertflg=false;
              v.nyy.doPost("/Sample/getSampleDetail",{sampleno:sampleno,showinfoflg:"0",ddqf:""}, 
                function(result){
                  if(result.status){
                     v.info=result.data.info;
                     v.getPbphList();
                  }else {
                    mui.toast(result.message);
                    return;
                  }
                }
              );
            }else{
              v.insertflg=true;
              var date = new Date();//获取当前时间
              var now_date = v.getFormatDate(date);
              v.info.sampletime="";
              v.info.ddh=v.paraInfo.ddh;
              v.info.wph=v.paraInfo.wph;
              v.info.sampleno = "";
              v.info.amount = 0.0;
              v.info.rollernumber = "";
              v.info.location = "1";
              v.info.machineno = "";
              v.info.tsdrollnolist = [{tsdrollno:"",machineno:""}];
              v.info.ddqf=v.paraInfo.ddqf;
              v.getPbphList(function(){
                v.info.clothcode = "";
                if(v.clothcodeLst.length>0){
                  v.info.clothcode = v.clothcodeLst[0].pbph;
                }
              });
            }
        },
        watch:{
          info: {
              handler: function (val) {
                  this.info.machineno = (val.machineno).toUpperCase();
                  this.info.rollernumber = (val.rollernumber).toUpperCase();
              },
              deep: true
          }
        }
    }
</script>

<style scoped>
  @import "../../static/css/mui.picker.min.css";
  @import "../../static/css/filterorder.css";
  @import "../../static/css/sampling.css";
  @import "../../static/css/update.css";
</style>



// WEBPACK FOOTER //
// src/components/samplingUpdate.vue